<template>
    <analytics-stat-card
        :href="props.href"
        :loading="loading"
        :error="Boolean(error)"
        class="grow"
        :value="value"
        :backgroundIcon="props.backgroundIcon"
    >
        <template v-slot:title>
            <slot name="title">Active Groups</slot>
        </template>
        <template v-slot:subtitle>
            <slot name="subtitle"></slot>
        </template>

        <span>{{ vxFormatCount(value) }}</span>

        <template v-slot:explainHeader>Active Groups</template>
        <template v-slot:explainContent>
            <p>Number of Groups that are in complete state and are actively sending Messages</p>

            <vx-button :href="`/settings/teams/${teamId}#/groups`" size="sm" color="muted">
                Go to Groups
                <font-awesome-icon widthAuto :icon="faArrowRight"></font-awesome-icon>
            </vx-button>
        </template>
    </analytics-stat-card>
</template>

<script setup>
import AnalyticsStatCard from '../../partial/AnalyticsStatCard.vue';
import { VxButton, vxFormatCount } from '@voxie/frontend-components';
import { outboundMessagesAnalyticsClient } from '~/services';
import { watch, computed } from 'vue';
import { useVersionedRequest } from '~/composables/useVersionedRequest';
import { metricsInputValidator } from '~/utils/analytics';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
    fetchParams: {
        type: Object,
        required: true,
        validator: metricsInputValidator,
    },
    href: {
        type: String,
    },
    backgroundIcon: {
        type: Object,
    },
});

const teamId = Spark.state.currentTeam.id;

const { loading, response, error, fetchData } = useVersionedRequest();

const value = computed(() => {
    if (error.value) {
        return undefined;
    }

    return response.value?.data?.values[0];
});

const params = computed(() => {
    return {
        range: props.fetchParams.range,
        filters: {
            ...props.fetchParams.filters,
            resource_types: props.fetchParams.filters.resource_types?.filter((type) => type !== 'other'),
        },
    };
});

watch(
    () => props.fetchParams,
    () => {
        fetchData(outboundMessagesAnalyticsClient.getTotalActiveGroups({ teamId }, params.value)).catch((e) => {
            console.error(e);
        });
    },
    { immediate: true, deep: true }
);

defineExpose({
    value,
    loading,
});
</script>
